module.exports = {
  searchBar: {
    placeholder: 'Brand, model, year ...',
  },
};



// WEBPACK FOOTER //
// ./javascripts/translations/price_guide/en.js